import React from "react";
import { Navigate } from "react-router-dom";
import Dashboard from '../modules/Dashboard/pages';
import Login from "../modules/Auth/pages/Login";
import Logout from "../modules/Auth/pages/Logout";
import LockScreen from "../modules/Auth/pages/Lock";
import Profile from "../modules/Teams/overview/profile";
import Vehicules from "../modules/Vehicules/pages";
import Drivers from "../modules/Drivers/pages";
import HelpPage from "../modules/Help/pages";
import AllNotifications from "../modules/Notifications/pages";
import Status from "../modules/Status/pages";
import Incidents from "../modules/Incidents/pages";
import Instructions from "../modules/Instructions/pages";
import HistoriqueVehicleChauffeur from "../modules/Historique/page";
import TypeInspections from "../modules/TypeInspection/page";
import Inspection from "../modules/Inspection/page";
import Users from "../modules/Users/pages";

import ForbiddenPassword from "../modules/Auth/pages/forbiddenPassword";
import PasswordRecovery from "../modules/Auth/pages/passwordRecovery";
import DetailVehicule from "../modules/Vehicules/component/DetailVehicule";
import DetailInspection from "../modules/Inspection/component/DetailInspection";
import Utilisateurs from "../modules/Administration/Users/page";
import UserDetail from "../modules/Administration/Users/component/UserDetail";
import NouveauVehicule from "../modules/Vehicules/component/NouveauVehicule";
import Formulaires from "../modules/Formulaires/page";
import DetailFormulaire from "../modules/Formulaires/components/DetailFormulaire";
import Cartes from "../modules/Cartes/page";
import Rappels from "../modules/Rappels/page";
import Roles from "../modules/Administration/Roles/page";
import DetailDriver from "../modules/Drivers/component/DetailDriver";
import DetailIncident from "../modules/Incidents/components/DetailIncident";
import NotificationDetailPage from "../modules/Notifications/component/DetailNotification";
import DetailTypeInspection from "../modules/Formulaires/components/DetailTypeInspection";
import Modification from "../modules/Formulaires/components/Modification";

const authProtectedRoutes = [
  { path: "/dashboard", component: <Dashboard /> },
  { path: "/profile/:id", component: <Profile /> },
  {
    path: "/",
    exact: true,
    component: <Navigate to="/dashboard" />,
  },
  { path: "*", component: <Navigate to="/dashboard" /> },
  { path: "/vehicules", component: <Vehicules /> },
  { path: "/inspection", component: <Inspection /> },
  { path: "/inspection/detail/{id}", copmponent: <Inspection /> },
  { path: "/incidents", component: <Incidents /> },
  { path: "/incident/detail/:id", component: <DetailIncident /> },
  { path: "/notifications", component: <AllNotifications /> },
  { path: "/aide", component: <HelpPage /> },
  { path: "/status", component: <Status /> },
  { path: "/chauffeur/detail/:id", component: <DetailDriver/> },
  { path: "/incidents", component: <Incidents/> },
  { path: "/instructions", component: <Instructions/> },
  { path: "/chauffeurs", component :<Drivers/>},
  { path: "/utilisateurs", component :<Utilisateurs/>},
  {path: "/historiques", component: <HistoriqueVehicleChauffeur/>},
  {path: "/type-inspection", component: <TypeInspections/>},
  { path: "/utilisateurs", component: <Users /> },
  { path: "/roles", component: <Roles /> },
  { path: "/vehicule/detail/:id", component: <DetailVehicule /> },
  { path: "/inspection/detail/:id", component: <DetailInspection /> }, 
  { path: "/utilisateur/detail/:id", component: <UserDetail /> }, 
  { path: "/nouveau-vehicule", component: <NouveauVehicule /> },
  { path: "/notification/detail/:id", component: <NotificationDetailPage /> }, 
  { path: "/formulaires", component: <Formulaires /> },
  { path: "/formulaires/detail/:id", component: <DetailFormulaire/> },
  { path: "/cartes", component: <Cartes /> },
  { path: "/rappels", component: <Rappels/> },
  { path: "/formulaire/type/:type", component: <DetailTypeInspection/> },
  { path: "/modifier/:type", component: <Modification/> },
];
const publicRoutes = [
  // Auth Page
  { path: "/lock", component: <LockScreen /> },
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
  {path: "/mot-de-passe-oublie", component: <ForbiddenPassword/>},
  {path: "/récupération-de-mot-de-pass", component :<PasswordRecovery/>}
];
export { authProtectedRoutes, publicRoutes };